import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';

export default function AccordionCustom({ expanded = false, sectionName, children }) {
    //children = elements inside the components <accordion> <children/> </accordion>
    return (
        <div>
            <Accordion defaultExpanded={expanded} >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ bgcolor: '#f5f5f5', color: '#1976d2', p: 1 }}

                >
                    {/* {sectionName} */}
                    <Typography  sx={{ fontWeight: 700, ml: 2 }}>
                        {sectionName.toUpperCase()}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{py:3}}>
                    {children}
                </AccordionDetails>
            </Accordion>
        </div>
    )
}